/**
 * GroupPay Payment status codes
 * https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses
 */
export enum PaymentStatus {
  READY = <any>'ready',
  PENDING = <any>'pending',
  INVOICED = <any>'invoiced',
  INVOICE_REJECTED = <any>'invoice-rejected',
  FUNDED = <any>'funded',
  PAY_SENT = <any>'pay-sent',
  PAY_REJECTED = <any>'pay-rejected',
  ERROR = <any>'error'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/payment-status.enum.ts